import React from "react";
import "./GameControl.css";
import { useWebSocket } from "../../context/WebSocketContext";

const GameControl = () => {
    const { connectionStatus } = useWebSocket();

    return (
        <div id="game-wrapper">
        </div>
    );
};

export default GameControl;